module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./tr.coffee"));
	}, "tr");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./app/locale/tr.coffee
// module id = 240
// module chunks = 97